module.exports = __webpack_public_path__ + "img/start-counting.aea0c93f.svg";